import { QRCodeCanvas } from "qrcode.react";

interface QRCodeProps {
  url: string;
}

export function QRCode({ url }: QRCodeProps): React.ReactNode {
  return <QRCodeCanvas value={url} size={200} level={"L"} includeMargin={false} />;
}
